<script>
import MixinAppSnack from './AppSnack'

export default {
    name: "TableLoadSnack",
    mixins: [MixinAppSnack],
    methods: {
        onDataLoadError() {
            this.setErrorSnack();
            this.setSnackText(this.$t('errorLoading'));
            this.openSnack();
        },
    },
}
</script>
